import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, DataGridItem, DataGridItemsResponse, SetFiltersRequest } from '../types';
import { GetRowsRequest, GetSummaryRequest, GetSummaryResponse } from '../../../grid/types/common';
import { RelayPatchCachingServersWebComponent } from '../component/RelayPatchCachingServersWebComponent';

export class RelayPatchCachingServersGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  response: any;

  constructor(public dependencies: any, private component: RelayPatchCachingServersWebComponent) {
    super();
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    return {
      summary: '',
      numItems: this.component.cachingServers.length,
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<DataGridItemsResponse> {
    const items = this.component.cachingServers.map(item => {
      return { ...item, actions: '*', priority: '0' } as DataGridItem;
    });

    return { rawEvents: items };
  }

  async setFilters(request: SetFiltersRequest): Promise<{} | undefined> {
    return;
  }
}
